

  document.addEventListener('DOMContentLoaded', function() {
    const texts = document.querySelectorAll('.text-overlay div');
    const videoBanner = document.querySelector('.video-banner');
    const button = document.getElementById('video-banner-btn');
    let currentIndex = 0;
    const interval = parseInt(videoBanner.getAttribute('data-text-display-duration')) || 3000; // Text display duration from the data attribute
    const pause = parseInt(videoBanner.getAttribute('data-pause-duration')) || 12000; // Pause duration from the data attribute
    const initialDelay = parseInt(videoBanner.getAttribute('data-initial-delay')) || 0; // Initial delay from the data attribute

    // Handle button scroll behavior
    button.addEventListener('click', function(event) {
      const btnUrl = button.getAttribute('href');
      if (!btnUrl || btnUrl === '#') {
        event.preventDefault(); // Prevent default link behavior
        const anchor = document.getElementById('main-collection-anchor');
        if (anchor) {
          anchor.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    });

    function showNextText() {
      texts.forEach((text, index) => {
        text.style.opacity = (index === currentIndex) ? '1' : '0';
      });
      currentIndex = (currentIndex + 1) % texts.length;

      if (currentIndex === 0) {
        clearInterval(textInterval);
        setTimeout(() => {
          texts.forEach(text => text.style.opacity = '0');
          setTimeout(() => {
            textInterval = setInterval(showNextText, interval);
          }, pause);
        }, interval);
      }
    }

    // Show the first text after the initial delay
    setTimeout(() => {
      if (texts.length > 0) {
        texts[0].style.opacity = '1';
      }
      // Start the interval for subsequent animations
      textInterval = setInterval(showNextText, interval);
    }, initialDelay);
  });